<template>
  <div class="social-card is-unselectable" :class="{ 'is-active': status }">
    <div class="social-logo" @click="update('status', !status)">
      <span class="icon is-large">
        <svg
          v-if='social === "x-twitter"'
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="32"
          height="32"
          fill='white'
        >
          <path
            d="M18.42,14.009L27.891,3h-2.244l-8.224,9.559L10.855,3H3.28l9.932,14.455L3.28,29h2.244l8.684-10.095,6.936,10.095h7.576l-10.301-14.991h0Zm-3.074,3.573l-1.006-1.439L6.333,4.69h3.447l6.462,9.243,1.006,1.439,8.4,12.015h-3.447l-6.854-9.804h0Z"
          />
        </svg>
        <i v-else class="fab fa-3x" :class="`fa-${social}`"></i>
      </span>
    </div>

    <div class="social-title has-text-weight-semibold">
      {{ social }}
    </div>

    <div class="social-link">
      <EditInput v-model="socialLink" is-link />
    </div>
  </div>
</template>

<script>
import EditInput from "@/components/EditInput";

export default {
  name: "SocialCard",
  components: {
    EditInput,
  },
  props: {
    social: String,
    link: String,
    status: Boolean,
  },
  computed: {
    socialLink: {
      get() {
        return this.link;
      },
      set(val) {
        this.update("link", val);
      },
    },
  },
  methods: {
    update(key, val) {
      const upd = {
        social: this.social,
        link: this.link,
        status: this.status,
        ...(key !== undefined && val !== undefined && { [key]: val }),
      };
      this.$emit("update", upd);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 5px;
  background-color: $cardFontColor;
  text-align: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  &.is-active {
    box-shadow: 0 0 3px 2px $brandColor;
  }

  &:hover {
    opacity: 0.9;
  }

  .social-logo {
    padding: 2rem;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    transition: all 0.1s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .social-link {
    margin: 2rem 0 1rem;
    width: 80%;
  }
}
</style>
